import { Badge, BadgeProps } from "@/components/Badge";
import { SvgSrcIcon } from "@/components/SvgSrcIcon";
import { scentMapping } from "@/helpers/scentMapping";
import { cn } from "@/helpers/utils";
import React from "react";

interface ProductScentProps extends Omit<BadgeProps, "children"> {
  scentName: string;
  size?: "sm" | "base";
}

export const ProductScent = (props: ProductScentProps) => {
  const { scentName, size = "base", ...rest } = props;
  return scentMapping[scentName] ? (
    <Badge pill size={size} {...rest}>
      <div className={cn("rounded-full", scentMapping[scentName]?.bgColor)}>
        <SvgSrcIcon
          className={size == "base" ? "h-5 w-5" : "h-4 w-4"}
          src={scentMapping[scentName].src}
          title={scentName}
        />
      </div>
      <span className={size == "base" ? "text-xs sm:text-sm" : "text-xs"}>
        {scentName}
      </span>
    </Badge>
  ) : (
    <span className={cn(size == "sm" && "text-sm")}>{scentName}</span>
  );
};
